global.backenduser="https://proyectox.titamedia.com:20002";
global.backendproject="https://proyectox.titamedia.com:20003";
global.wsnotification="https://proyectox.titamedia.com:20005/ws-notification";